import React, {useState, useEffect} from 'react';

function SelectCompany({billing, onSelect}) {
    const [selectedId, setSelectedId] = useState("");

    // default select first
    useEffect(() => {
        if (!selectedId && billing && Object.keys(billing).length > 0) {
            setSelectedId(Object.keys(billing)[0]);
        }
    }, [billing, selectedId]);

    const handleChange = (e) => {
        const id = e.target.value;
        setSelectedId(id);
        onSelect(id); // 🔥 send to parent
    };

    return (
        <>
            <label htmlFor="ekoda-company" className="">Naziv podjetja</label>
            <select name={"ekoda-company"} className="form-select" value={selectedId} onChange={handleChange}>
                {Object.entries(billing).map(([id, value]) => (
                    <option key={id} value={id}>
                        {value?.billing?.bill_0?.company}
                    </option>
                ))}
            </select>
        </>
    );
}

export default SelectCompany;
